import { Injectable, inject } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';

@Injectable({
    providedIn: 'root'
})
export class ImageGalleryService {
    private lightbox = inject(Lightbox);

    galleryId = 'formbird-gallery';
    images: { [p:string]: string[] } = {};

    public addImageToGallery(galleryId: string = this.galleryId, imageSrc: string) {
        const images = this.images[galleryId];
        if (images) {
          this.images[galleryId].push(imageSrc)
        } else {
          this.images[galleryId] = [imageSrc]
        }
    }

    open(galleryId: string = this.galleryId, imageSrc) {
        this.lightbox.open(this.images[galleryId].map(src => ({ src: imageSrc, caption: '', thumb: imageSrc })))
    }
}
